
enum CheckLocation {

    HOME = 0,
    OFFICE = 1
}

export default CheckLocation;